export function getMensagemDeErroBackend(error : any) : string{
    return error && error.response
        && error.response.data
        && error.response.data.validation
        && error.response.data.validation[0].message
}